/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { DeleteOrganizationMutationResponse, DeleteOrganizationPathParams, DeleteOrganization400, DeleteOrganization401, DeleteOrganization403, DeleteOrganization404, DeleteOrganization409, DeleteOrganization500 } from "../../types/organizationController/DeleteOrganization.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { deleteOrganization } from "../../client/organizationController/deleteOrganization.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const deleteOrganizationMutationKey = () => [{ url: '/api/organizations/:organizationId' }] as const

export type DeleteOrganizationMutationKey = ReturnType<typeof deleteOrganizationMutationKey>

export function deleteOrganizationMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = deleteOrganizationMutationKey()
        return mutationOptions<DeleteOrganizationMutationResponse, ResponseErrorConfig<DeleteOrganization400 | DeleteOrganization401 | DeleteOrganization403 | DeleteOrganization404 | DeleteOrganization409 | DeleteOrganization500>, {organizationId: DeleteOrganizationPathParams["organizationId"]}, TContext>({
          mutationKey,
          mutationFn: async({ organizationId }) => {
            return deleteOrganization(organizationId, config)
          },
        })

}

/**
 * @summary Delete organization
 * {@link /api/organizations/:organizationId}
 */
export function useDeleteOrganization<TContext>(options: 
{
  mutation?: UseMutationOptions<DeleteOrganizationMutationResponse, ResponseErrorConfig<DeleteOrganization400 | DeleteOrganization401 | DeleteOrganization403 | DeleteOrganization404 | DeleteOrganization409 | DeleteOrganization500>, {organizationId: DeleteOrganizationPathParams["organizationId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? deleteOrganizationMutationKey()

          const baseOptions = deleteOrganizationMutationOptions(config) as UseMutationOptions<DeleteOrganizationMutationResponse, ResponseErrorConfig<DeleteOrganization400 | DeleteOrganization401 | DeleteOrganization403 | DeleteOrganization404 | DeleteOrganization409 | DeleteOrganization500>, {organizationId: DeleteOrganizationPathParams["organizationId"]}, TContext>
          

          return useMutation<DeleteOrganizationMutationResponse, ResponseErrorConfig<DeleteOrganization400 | DeleteOrganization401 | DeleteOrganization403 | DeleteOrganization404 | DeleteOrganization409 | DeleteOrganization500>, {organizationId: DeleteOrganizationPathParams["organizationId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DeleteOrganizationMutationResponse, ResponseErrorConfig<DeleteOrganization400 | DeleteOrganization401 | DeleteOrganization403 | DeleteOrganization404 | DeleteOrganization409 | DeleteOrganization500>, {organizationId: DeleteOrganizationPathParams["organizationId"]}, TContext>
      
}